import React, { forwardRef } from 'react'
import { usePaymentInputs } from 'react-payment-inputs'

import { TextInput, TextInputProps } from '../TextInput'

export interface CreditCardExpiryInputProps extends TextInputProps {}

export const CreditCardExpiryInput = forwardRef(
  ({ ...restProps }: CreditCardExpiryInputProps, ref) => {
    const { getExpiryDateProps } = usePaymentInputs()

    return <TextInput {...getExpiryDateProps()} label="Expiry Date" ref={ref} {...restProps} />
  },
)

export default CreditCardExpiryInput
